export const normalizeCategoryData = (data: any) => {
    return data?.productCategories?.items || data?.serviceCategories?.items || [];
};
